module.exports = __webpack_public_path__ + "static/block-a405ddf9c21f8d8a45b2515251dc3a92.png";